import { defineComponent, inject, withDirectives, openBlock, createElementBlock, createTextVNode, toDisplayString, unref } from "vue";
import directive from "../directives/Linkify/index.mjs";
const _hoisted_1 = ["title"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppSidebarHeader",
  props: {
    name: {},
    title: {},
    linkify: { type: Boolean }
  },
  setup(__props) {
    const headerRef = inject("NcAppSidebar:header:ref");
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("h2", {
        ref_key: "headerRef",
        ref: headerRef,
        tabindex: "-1",
        title: _ctx.title
      }, [
        createTextVNode(toDisplayString(_ctx.name), 1)
      ], 8, _hoisted_1)), [
        [unref(directive), { text: _ctx.name, linkify: _ctx.linkify }]
      ]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcAppSidebarHeader.vue_vue_type_script_setup_true_lang-Bk4yFBHY.mjs.map
